import { promiseImpl } from 'ejs';
import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import{HomeProps} from './Home.tsx'
import CardEditor from "./CardEditor.tsx";
import { Intent, Classes } from "@blueprintjs/core";
import { Button, Card, Elevation,Slider, Overlay,H4 } from "@blueprintjs/core";
//import { Document, Page } from 'react-pdf/dist/esm/entry.parcel.js';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

import './cardpdf.css';
import {Toaster, Position} from "@blueprintjs/core";
const toaster=Toaster.create({
  className: "my-toaster",
  position: Position.TOP_RIGHT
});

/*const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};*/
export  class CardPdf extends React.Component  <HomeProps> {
  state = {
    name: '',
    file:'',
    zoom:0.5,
    largeur:'620px',
    isOpenPdf:'none',
    isNotOpenPdf:'flex',
    numPages:0,
    force_width:'360px',
    isOpenEdit:false,
    title_document_creation:'',
    description_document_creation:'',
    objectif_document_creation:'',
    isOpenDelete:false,
    status_published:"eye-off",
    showcontenu:'block',
    elargir:'arrow-right',
    parent_height:'auto'
  }  
  
  constructor(props) {
        super(props);
        pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
        this.setState({file:props.url_video})
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
    this.setState({file:this.props.url_video})
    this.setState({title_document_creation:this.props.title_document});
    this.setState({description_document_creation:this.props.description});
    this.setState({objectif_document_creation:this.props.objectif})
       
  }
 
  componentDidUpdate(prevProps, prevState) {
    //console.log(prevProps)
    if(prevProps.url_video!=this.state.file) this.setState({file:prevProps.url_video})
  }
  handle_published=()=>
  {
    console.log("handle_published");
    if(this.state.status_published=='eye-off'){
      this.setState({status_published:'eye-open'});
      toaster.show( {icon:'eye-open', intent:Intent.SUCCESS,timeout:2000,message:"Le document est disponible en ligne"});
    }else{
      this.setState({status_published:'eye-off'});
      toaster.show( {icon:'eye-off', intent:Intent.DANGER,timeout:2000,message:"Le document n'est plus disponible en ligne"});
    }
  }
  onFileChange=function (event) {
    this.setState({file:event.target.files[0]})
  }

   onDocumentLoadSuccess=function(ev) {
    console.log("onDocumentLoadSuccess");
    console.log(ev._pdfInfo.numPages);
    this.setState({numPages:ev._pdfInfo.numPages})
    this.setState({isOpenPdf:'none'});
    this.setState({isNotOpenPdf:'flex'});
    
    //setNumPages(nextNumPages);
  }
  renderLoader=function renderLoader(ev)
  {
    console.log("ici");
    console.log(ev);
    console.log(this);
  }
  handletaille=()=>{
    this.setState({force_width:"100%"});
    this.setState({showcontenu:"block"});
    this.setState({elargir:"arrow-left"});
  }
  render() {
    
    const {youtube_frame,url_video,title_document,description,objectif,isnotdocument,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handlehandleSelectionGetLoginSelectionChangeLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;

    return(
     <div style={{display:isnotdocument,width:this.state.force_width,margin:4}}>
     
     <Card style={{width:this.state.force_width,margin:4,objectFit:'contain'}} interactive={true} elevation={Elevation.TWO}>
     <div style={{textAlign: 'right'}}>
       <Button onClick={(ev)=>{ev.preventDefault();this.setState({parent_height:"80px"});this.setState({showcontenu:"none"});this.setState({typeflex:'initial'})}} className={Classes.OUTLINED } icon="minimize" title="Réduire" />
       <Button onClick={(ev)=>{ev.preventDefault();this.setState({parent_height:"auto"});this.setState({showcontenu:"block"});if(this.props.type_audio =='true') this.setState({typeflex:'100%'});if(this.props.type_audio =='true') this.setState({parent_height:280})}} className={Classes.OUTLINED } icon="maximize" title="Augmenter" />
       <Button onClick={(ev)=>{
          ev.preventDefault();
          if(this.state.elargir=='arrow-right')
          {
            this.setState({force_width:"100%"});
            this.setState({showcontenu:"block"});
            this.setState({elargir:"arrow-left"});
            this.setState({isOpenPdf:'flex'});
            this.setState({isNotOpenPdf:'none'});
          }
          else
          {
            this.setState({force_width:"360px"});
            this.setState({elargir:"arrow-right"});
            this.setState({isOpenPdf:'none'});
            this.setState({isNotOpenPdf:'flex'});
          }
        }}
              
        className={Classes.OUTLINED } icon={this.state.elargir} title="Elargir" />
     </div>
     <h3><a href="">{title_document}</a></h3>
     <p><b>{description}</b></p>
     <p>{objectif}</p>
     {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenEdit:true});}} className={Classes.OUTLINED +" "+ Classes.LARGE} icon="edit" title="Editer" />:<div></div>}
     {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:true});}} className={Classes.OUTLINED+" "+ Classes.INTENT_DANGER +" " + Classes.LARGE} icon="trash" title="Effacer" />:<div></div>}
     {this.props.toolbar=='true'?<Button className={Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_WARNING} icon={this.state.status_published} title="Cours en ligne" onClick={(ev)=>{ev.preventDefault();this.handle_published();}}/>:<div></div>}
     {this.props.toolbar!='true'?<CardEditor _onUploadtext={this.props._onUploadtext} fromChildren={this.props.fromChildren} matiere_id={this.props.matiere_id} handletaille={this.handletaille} userid={this.props.userid} recordingsbydate={this.props.recordingsbydate} id_document={this.props.id_document} title_document={title_document}/>:null}
     <Overlay isOpen={this.state.isOpenDelete} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Effacer le document {this.props.title_document}</H4>
                       
                        <p style={{marginTop:20}}>
                           Etes-vous sûr de vouloir effacer le document {this.props.title_document} ?
                        </p>
                                              
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:false});}}>Annuler</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();this.setState({isOpenDelete:false});
                              
                              var xhr = new XMLHttpRequest();
                              xhr.overrideMimeType("application/json");
                              var that=this;
                              xhr.open('GET','/api/public/deldocument?id_document='+this.props.id_document)
                              this.setState({file:''})
                              xhr.setRequestHeader("Content-Type", "application/json");

                              //send the form data
                              xhr.send();

                                    xhr.onreadystatechange = function() {
                                        if (xhr.readyState == XMLHttpRequest.DONE) {
                                                      
                                        if(xhr.status==200) 
                                        { 
                                        
                                          console.log(xhr.responseText);
                                          //that.props.onchildrenevent();
                                          that.props.LoadDataDocumentsDirect(-1)
                                          return;
                                          var jsonResponse = JSON.parse(xhr.responseText);
                                          console.log(jsonResponse);
                                          
                                          
                                          
                                        }
                                        if(xhr.status==404) {console.log( {message:"erreur"}); }
                                        if(xhr.status==500) {console.log( {message:"erreur"}); }
                                        
                                        }
                                      
                                    }
                              
                              
                              
                              
                              }} style={{ margin: "" }}>
                                Valider
                            </Button>
                            
                            
                        </div>
                    </div>
     </Overlay>
    
      <div style={{display:this.state.showcontenu,zIndex:0}}>
       <p style={{fontSize:14, marginTop:'4px'}} >Nombre de page(s): {this.state.numPages}<a href={this.state.file} target="_blank">   <b>Ouvrir</b></a></p>
       <div style={{marginTop:25}} >{/*style={{transform: "scale("+this.state.zoom+")", width:this.state.largeur}} className="Example__container">*/}
      
       <div>{/*onClick={(ev)=>{window.open(this.state.file,"_blank");}}style={{cursor:"pointer"}}, transform: "scale("+this.state.zoom+")", width:this.state.largeur}} className="Example__container__document"*/}
          <Document onClick={(ev)=>{window.open(this.state.file,"_blank");}}style={{cursor:"pointer"}} file={this.state.file} onLoadSuccess={(ev)=>{this.onDocumentLoadSuccess(ev)}} loading={(ev)=>{this.renderLoader(ev)}} >
           {Array.from(new Array(1), (el, index) => ( index > 0 ? <Page renderMode={this.state.isOpenPdf} style={{display:this.state.isOpenPdf}} key={`page_${index + 1}`} pageNumber={index + 1} /> : <Page renderMode={this.state.isNotOpenPdf} key={`page_${index + 1}`} pageNumber={index + 1} />))}
              
           
          </Document>
          <iframe style={{display:this.state.isOpenPdf,height:'960px',width:'100%'}}src={this.state.file}></iframe>
          
        </div>
      
        
      </div>
      </div>
    </Card>
    <Overlay isOpen={this.state.isOpenEdit} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
      
      <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
      
        <H4>Edition d'un document</H4>
        <div style={{marginTop:5}}><span>Titre</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:ev.target.value,description:this.state.description_document_creation,objectif:this.state.objectif_document_creation});this.setState({title_document_creation:ev.target.value})}} value={this.state.title_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir le titre de votre document"/></div>
        <div style={{marginTop:5}}><span>Description</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:ev.target.value,objectif:this.state.objectif_document_creation});this.setState({description_document_creation:ev.target.value})}} value={this.state.description_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir une description votre document"/></div>
        <div style={{marginTop:5}}><span>Objectif</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:this.state.description_document_creation,objectif:ev.target.value});this.setState({objectif_document_creation:ev.target.value})}} value={this.state.objectif_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir un objectif ou une consigne"/></div>
        <div style={{marginTop:10}}>
          <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenEdit:false});}}>Annuler</Button>
          <Button style={{marginLeft:5}} intent={Intent.SUCCESS} onClick={(ev)=>{ev.preventDefault();this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:this.state.description_document_creation,objectif:this.state.objectif_document_creation,update:true});this.setState({isOpenEdit:false});}}>Valider la modification</Button>
        </div>
      </div>
      </Overlay>
    </div>);
   
}
}

